import createDocumentStoreClass from './lib/create_document_store_class';
import ReportConverter from 'scripts/adapters/immutable_converters/report_converter';

export default createDocumentStoreClass({
  converter: ReportConverter,
});



// WEBPACK FOOTER //
// ./src/scripts/adapters/stores/report_store.js